import PropTypes from 'prop-types';
import { useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { Button, Col, Row } from '@arkestro/arkestro-design-system';
import Footer from 'components/on_board/Footer/Footer';

const FindOrCreateOrganization = ({ setOrgStep }) => {
  const [disabled, setDisabled] = useState(false);
  const { t } = useTranslation('common');

  return (
    <>
      <Row>
        <Col xs={24}>
          <div className='title'>{t('find_or_create_organization.title')}</div>
        </Col>
      </Row>
      <Row style={{ marginTop: 15 }}>
        <Col xs={24}>
          <div style={{ color: '#95979e' }}>{t('find_or_create_organization.subtitle')}</div>
        </Col>
      </Row>
      <Row gutter={16} justify='center' style={{ marginTop: 30 }}>
        <Col>
          <Button
            disabled={disabled}
            onClick={() => {
              setDisabled(true);
              setOrgStep({ currentOrgStep: 'create_org' });
            }}
            type="secondary"
          >
            {t('general.create_new_organization')}
          </Button>
        </Col>
      </Row>
      <Footer />
    </>
  );
};

FindOrCreateOrganization.propTypes = {
  setOrgStep: PropTypes.func.isRequired
};

export default FindOrCreateOrganization;
